var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 109,
    viewBox: "0 0 239 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3084 12.6818L11.5768 100.503C11.5786 101.077 12.0447 101.541 12.6182 101.539L233.379 101.054C233.951 101.053 234.415 100.588 234.415 100.015L234.431 12.6414C234.431 12.0674 233.965 11.602 233.391 11.6021L12.3473 11.6395C11.7723 11.6396 11.3066 12.1067 11.3084 12.6818Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8416 7.33311C4.8416 6.47336 5.53775 5.77705 6.3975 5.77685L228.699 5.7246C229.561 5.7244 230.26 6.42379 230.26 7.28573L230.26 94.5917C230.26 95.4514 229.564 96.1477 228.704 96.1479L6.4032 96.2002C5.54126 96.2004 4.84169 95.501 4.84169 94.6391L4.8416 7.33311Z",
    stroke: "black",
    strokeWidth: 1.03913
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2352 43.8401C82.1681 50.5282 74.3528 56.5602 74.3534 59.6029C74.3534 59.8216 74.3799 60.0295 74.4623 60.2174C80.2124 73.3351 108.046 83.0469 132.444 72.3843C156.846 61.7207 163.886 40.4915 163.106 22.397C163.084 21.8888 162.865 21.4792 162.47 21.1606C158.588 18.0339 137.524 23.7958 115.381 33.4736C107.551 36.895 100.347 40.4523 94.2352 43.8401Z",
    fill: "white",
    stroke: "#1C1C1C",
    strokeWidth: 1.03913
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7334 60.8242C82.8311 59.8419 93.54 58.3296 102.788 55.5654C128.29 47.9427 147.31 35.082 160.348 23.9395",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7334 60.8242C82.8311 59.8419 93.54 58.3296 102.788 55.5654C128.29 47.9427 147.31 35.082 160.348 23.9395",
    stroke: "#1C1C1C",
    strokeWidth: 1.03913
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentSuccess);
export default __webpack_public_path__ + "static/media/appointment-success.ad3f3a3a4d36691579ec53158a4492ce.svg";
export { ForwardRef as ReactComponent };